import React from 'react';
import { Text } from '@mantine/core';

export const Eyebrow: React.FC<{ children: React.ReactNode; color?: string }> = ({
  children,
  color,
}) => (
  <Text
    size="xs"
    fw={600}
    c={color ?? 'dimmed'}
    style={{
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
      fontVariantNumeric: 'tabular-nums',
    }}
  >
    {children}
  </Text>
);

export const NumberMono: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({
  children,
  style,
}) => <span style={{ fontVariantNumeric: 'tabular-nums', ...style }}>{children}</span>;
